import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import { Headers } from 'shared/constants/headers';

export interface SmartyStreetsInputs {
  key: string;
  search: string;
  source: string;
  max_result: number;
}

export interface SmartyStreetsResponse {
  suggestions: Array<SmartyStreetsResponseItem>;
}

export type SmartyStreetsResponseItem = {
  city: string;
  entries: number;
  state: string;
  street_line: string;
  zipcode: string;
  postal: string;
  secondary: string;
  address_line: string;
};

const getSuggestions = async (
  url: string,
  headers: Headers,
): Promise<SmartyStreetsResponse> => {
  const reqHeaders = {
    ...headers,
  };

  const response = await unauthenticatedFetch(`${url}`, {
    method: 'GET',
    cache: 'no-cache',
    headers: reqHeaders,
  });

  return response.json() as Promise<SmartyStreetsResponse>;
};

export default getSuggestions;
